import React from "react";

interface OrderErrorDisplayProps {
  error: string;
  onBackClick: () => void;
}

const OrderErrorDisplay: React.FC<OrderErrorDisplayProps> = ({
  error,
  onBackClick,
}) => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4">
      <div className="text-h16 font-bold text-red-500">Error</div>
      <div className="text-h14 text-gray-600">{error}</div>
      <button
        onClick={onBackClick}
        className="rounded-md bg-tertiaryBlue-4 px-4 py-2 text-white hover:bg-tertiaryBlue-5"
      >
        Go Back
      </button>
    </div>
  );
};

export default OrderErrorDisplay;
